const UserTypes = {
    SET_AD_USER_DETAILS: 'SET_AD_USER_DETAILS',
    SET_USER_SERVICE_INFO: 'SET_USER_SERVICE_INFO',
    SET_PROFILE_PICTURE: 'SET_PROFILE_PICTURE',
    SET_USER_ROLES: 'SET_USER_ROLES',
    SET_USER_GRAPH_DATA: 'SET_USER_GRAPH_DATA',
    SET_USER_SERVICE_PERMISSION: 'SET_USER_SERVICE_PERMISSION'
}

export default UserTypes